/* Kibana */
export const KIBANA_LOGIN = "KIBANA_LOGIN";
export const KIBANA_LOGIN_SUCCESS = "KIBANA_LOGIN_SUCCESS";
export const KIBANA_LOGIN_ERROR = "KIBANA_LOGIN_ERROR";
